import { Container } from "./styled/tab-list";

export default Container;
